(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabbed-products')) {
    class TabbedProducts extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.tabbed-products__tab'));
        this.items = Array.from(this.querySelectorAll('.tabbed-products__item'));
        this.track = this.querySelector('.tabbed-products__track');
        this.empty = this.querySelector('.tabbed-products__empty');
        this.prev = this.querySelector('.tabbed-products__arrow--prev');
        this.next = this.querySelector('.tabbed-products__arrow--next');

        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
        this.prev?.addEventListener('click', () => this.scrollByPage(-1));
        this.next?.addEventListener('click', () => this.scrollByPage(1));
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        window.addEventListener('resize', () => this.updateArrows());

        // Load every card image up front so switching tabs shows products instantly
        this.querySelectorAll('.tabbed-products__item img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });

        const active = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
        if (active) this.select(active);
        else this.updateArrows();
      }

      select(selected) {
        this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab === selected)));
        this.querySelectorAll('.tabbed-products__image-item').forEach((el) => {
          el.classList.toggle('is-active', el.dataset.imageId === selected.dataset.image);
        });

        const tag = (selected.dataset.tag || '').trim().toLowerCase();
        let visible = 0;
        this.items.forEach((item) => {
          const tags = (item.dataset.tags || '').split('||');
          const show = tag === '' || tags.includes(tag);
          item.hidden = !show;
          item.classList.remove('is-entering');
          if (show) {
            item.style.setProperty('--tp-index', Math.min(visible, 8));
            visible += 1;
          }
        });
        // Restart the entrance animation for the cards that are now visible
        void this.track.offsetWidth;
        this.items.forEach((item) => {
          if (!item.hidden) item.classList.add('is-entering');
        });

        if (this.empty) this.empty.hidden = visible > 0;
        this.track.scrollTo({ left: 0, behavior: 'auto' });
        this.updateArrows();
      }

      scrollByPage(direction) {
        this.track.scrollBy({ left: direction * this.track.clientWidth * 0.8, behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.prev || !this.next) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 1;
        this.prev.disabled = this.track.scrollLeft <= 0;
        this.next.disabled = this.track.scrollLeft >= max;
      }
    }

    customElements.define('tabbed-products', TabbedProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
